import { render } from "./ExceptionLog.vue?vue&type=template&id=4517908c&ts=true"
import script from "./ExceptionLog.vue?vue&type=script&lang=ts"
export * from "./ExceptionLog.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__